import * as swcHelpers from '@swc/helpers';
import '../models/adyen/payment-type.js';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import { getCreditCardBrandsIcons } from '../utils/get-creditcard-brands-icons.js';
import { getPaymentMethodIcon } from '../utils/get-payment-method-icon.js';
import { getBankIcon } from '../utils/get-bank-icons.js';

const cartPaymentMethods = ({ cartPaymentMethods: cartPaymentMethods1  }, isApplePayActive = false)=>{
    var ref;
    return (ref = cartPaymentMethods1 || []) === null || ref === void 0 ? void 0 : ref.reduce((acc, { name: name1 , psp , issuers , brands , installmentTypes , donations =[]  })=>{
        if (!isApplePayActive && name1 === PaymentMethod.APPLE_PAY) {
            return acc;
        }
        const expressPaymentMethods = [
            PaymentMethod.APPLE_PAY,
            PaymentMethod.GOOGLE_PAY
        ];
        const icons = (brands === null || brands === void 0 ? void 0 : brands.length) && !expressPaymentMethods.includes(name1) ? getCreditCardBrandsIcons(brands) : getPaymentMethodIcon(name1);
        const paymentMethod = swcHelpers.objectSpread({
            name: name1,
            provider: psp
        }, (icons === null || icons === void 0 ? void 0 : icons.length) && {
            icons
        }, (issuers === null || issuers === void 0 ? void 0 : issuers.length) && {
            items: issuers.map(({ id , name  })=>({
                    key: id,
                    value: name,
                    icon: getBankIcon(name)
                })
            )
        }, (brands === null || brands === void 0 ? void 0 : brands.length) && {
            brands
        }, (installmentTypes === null || installmentTypes === void 0 ? void 0 : installmentTypes.length) && {
            items: installmentTypes.map(({ id , installments  })=>({
                    key: id,
                    value: String(installments)
                })
            )
        }, (donations === null || donations === void 0 ? void 0 : donations.length) && {
            donations
        });
        return [
            ...acc,
            paymentMethod
        ];
    }, []);
};

export { cartPaymentMethods };
//# sourceMappingURL=cart-payment-methods.js.map
